import { BaseContainerModel } from '../../base-container.model';
import * as fromDatatype from '../../../datatype-library/index';

export class BinAvailabilityContainer extends BaseContainerModel {
  line_guid: fromDatatype.GuidDataFieldInterface;
  hdr_guid: fromDatatype.GuidDataFieldInterface;
  line_code: fromDatatype.VarcharDatatypeInterface;
  hdr_code: fromDatatype.VarcharDatatypeInterface;
  container_measure: fromDatatype.NumericDatatypeInterface;
  container_uom: fromDatatype.VarcharDatatypeInterface;
  container_qty: fromDatatype.NumericDatatypeInterface;
  qty: fromDatatype.NumericDatatypeInterface;
  item_guid: fromDatatype.GuidDataFieldInterface;
  bins_available: fromDatatype.NumericDatatypeInterface;
  bins_reserved: fromDatatype.NumericDatatypeInterface;
  branch_guid: fromDatatype.GuidDataFieldInterface;
  location_guid: fromDatatype.GuidDataFieldInterface;
  qty_available: fromDatatype.NumericDatatypeInterface;
  qty_reserved: fromDatatype.NumericDatatypeInterface;
  container_qty_available: fromDatatype.NumericDatatypeInterface;
  locked_qty: fromDatatype.NumericDatatypeInterface;
  container_width: fromDatatype.NumericDatatypeInterface;
}